'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMoreHoriz = function NavigationMoreHoriz(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
NavigationMoreHoriz = (0, _pure2.default)(NavigationMoreHoriz);
NavigationMoreHoriz.displayName = 'NavigationMoreHoriz';
NavigationMoreHoriz.muiName = 'SvgIcon';

exports.default = NavigationMoreHoriz;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/navigation/more-horiz.js
// module id = 3291
// module chunks = 0